<template>
    <BaseModal :isShow="isShow" @close="emit('close')" size="md">
        <div class="flex flex-col w-full p-6 gap-6">
            <div class="">مشتری گرامی لطفا درگاه پرداخت موردنظر خود را انتخاب نمایید.</div>
            <div class="flex justify-between">
               <div v-for="item in items" :key="item.id" class="w-[60px] h-[60px] laptop:w-[120px] laptop:h-[120px] bg-blue-200 border border-blue-700 flex justify-center items-center cursor-pointer" @click="selectOPG(item.url)">
                    <NuxtImg 
                        sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                        width="1000"
                        height="1000"
                        quality="100"
                        format="webp"
                        :src="item.img"
                        alt=""
                    />
               </div>
            </div>
        </div>
    </BaseModal>
</template>
  
<script setup>
const props = defineProps({
    isShow: Boolean
})

const emit = defineEmits(['close', 'select'])

const items = [
    { id: 0, img: '/img/parsian.webp', url: 'https://sgas.ir/PEC_OPG/' },
    { id: 1, img: '/img/iranKish.webp', url: 'https://sgas.ir/IKC_OPG/' },
    // { id: 2, img: '/img/eghtesadNovin.webp', url: 'https://sgas.ir/ENB_OPG/' },
]

const selectOPG = (selectedURL) => {
    emit('select', selectedURL)
}

</script>